export default "__VITE_ASSET__7e19de4a__"